module.exports = __webpack_public_path__ + "static/VoteYay_Long_4C.1926b6e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/VoteYay_Long_4C.png
// module id = 36
// module chunks = 94818538752247 118551011512839 229387226736268